"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const zustandStore_1 = require("../../../../zustandStore");
const slices_1 = require("../../../../zustandStore/slices");
const lexico = new lexico_1.default();
const sortOptionsWithLabels = {
    mostRecent: lexico.trc('Button label', 'Most recent'),
    requester: lexico.trc('Button label', 'Requester'),
    lowToHigh: lexico.trc('Button label', 'Amount: low to high'),
    highToLow: lexico.trc('Button label', 'Amount: high to low'),
};
const SortApprovals = () => {
    const sortValue = (0, zustandStore_1.useZustand)(state => state.approvals.sortValue);
    const { setSortApprovalsValue } = (0, zustandStore_1.useZustand)();
    const [currentSortKey] = Object.keys(sortValue);
    return ((0, jsx_runtime_1.jsx)(material_1.FormControl, { variant: "outlined", size: "small", style: { padding: 0 }, children: (0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "sort-approvals", labelId: "sort-select-label", id: "sort-select", value: currentSortKey, onChange: event => {
                const selectedOption = event.target.value;
                const newSortValue = { [selectedOption]: slices_1.sortApprovalsOptions[selectedOption] };
                setSortApprovalsValue(newSortValue);
            }, label: "Sort", renderValue: selected => `Sort: ${sortOptionsWithLabels[selected]}`, children: Object.entries(slices_1.sortApprovalsOptions).map(([key]) => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: key, children: sortOptionsWithLabels[key] }, key))) }) }));
};
exports.default = SortApprovals;
